import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ArticleCard from './ArticleCard';
import styles from './ArticleTab.scss';

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={props.className}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const newsTypes = [
  {type: 'All', label: 'All'},
  {type: 'news_article', label: 'News Article'},
  {type: 'product_update', label: 'Product Updates'},
];

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function ArticleTab(props) {
  const {articles, handleFilterChange, currentOption = 0, isMobile} = props;
  const handleChange = (event, index) => {
    handleFilterChange(newsTypes[index]);
  };

  return (
    <div>
      <Tabs
        className="mb-4"
        TabIndicatorProps={{style: {backgroundColor: "#3399FF"}}}
        value={currentOption}
        onChange={handleChange}
        variant={isMobile ? "scrollable" : "standard"}
        scrollButtons="auto"
        aria-label="article tabs">
        {
          newsTypes.map((tab, index) => {
            return (
              <Tab className={styles.upper} key={`articleTab_${index}`} label={tab.label} {...a11yProps(index)} />
            );
          })
        }
      </Tabs>
      {
        newsTypes.map((tab, index) => {
          return (
            <TabPanel key={`articleTabPanel_${index}`} value={currentOption} index={index}>
              {articles.map((item, index) => <ArticleCard key={index} article={item} display="column" />)}
            </TabPanel>
          );
        })
      }
    </div>
  );
}

ArticleTab.propTypes = {
  articles: PropTypes.array,
  handleFilterChange: PropTypes.func,
  currentOption: PropTypes.number,
  isMobile: PropTypes.bool,
};

export default ArticleTab;
